// SPDX-License-Identifier: LicenseRef-Proprietary
// Copyright (c) 2025 Mann Contractual Management Ltd

import { useEffect } from "react"

const useEventListener = (target, type, listener, ...options) => {
  useEffect(() => {
    target.addEventListener(type, listener, ...options)
    return () => target.removeEventListener(type, listener, ...options)
  }, [target, type, listener, options])
}

export default useEventListener
